// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-tabs--card {\n  height: calc(80vh - 110px);\n}\n.el-tab-pane {\n  height: calc(80vh - 110px);\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
